import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BRAND } from '../../data/constants.js';

const LINKS = [
  ['Venta','/buscar?op=venta'],['Alquiler','/buscar?op=alquiler'],
  ['Emprendimientos','/buscar?op=venta&dev=1'],['Tasación','/vender?modo=tasacion'],
  ['Vender mi propiedad','/vender'],['Favoritos','/favoritos'],
  ['Comparador','/comparar'],['Nosotros','/nosotros'],['Contacto','/contacto'],
];

export default function MobileMenu({ open, onClose }) {
  const nav = useNavigate();
  useEffect(() => { document.body.style.overflow = open ? 'hidden' : ''; return () => { document.body.style.overflow = ''; }; }, [open]);
  if (!open) return null;
  return (
    <div className="mm-overlay" onClick={onClose}>
      <div className="mm-panel" onClick={e => e.stopPropagation()} role="dialog" aria-label="Menú">
        <div className="mm-head">
          <span className="brand-mark">Abriola</span>
          <button className="iconbtn" onClick={onClose} aria-label="Cerrar">✕</button>
        </div>
        <nav className="mm-nav">
          {LINKS.map(([t, h]) => (
            <Link key={t} to={h} onClick={onClose}>{t} ›</Link>
          ))}
        </nav>
        <a className="btn btn-wa btn-block mm-wa" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">
          WhatsApp
        </a>
      </div>
    </div>
  );
}
